import { countriesConfig, getAsCountryISO2, isCountryISO2 } from '@lib/shared';
import lodashSortBy from 'lodash-es/sortBy';
import type { ComputedRef } from 'vue';

import type { CountryOption } from '~/types/signup/country.type';
import { Locale } from '~i18n/i18nConfig';

export interface UseCountriesReturnType {
    countries: ComputedRef<CountryOption[]>;
    getLocalizedCountry: (countryCode: string) => string | null;
    makeReactiveLocalizedCountry: (countryCode: MaybeRefOrGetter<string>) => ComputedRef<string | null>;
}

export const useCountries = (): UseCountriesReturnType => {
    const { locale } = useI18n();

    const getLocalizedCountry: UseCountriesReturnType['getLocalizedCountry'] = countryCode =>
        isCountryISO2(countryCode) ? countriesConfig[getAsCountryISO2(countryCode)].i18nNames[locale.value] : null;

    return {
        countries: computed<CountryOption[]>(() =>
            lodashSortBy(
                Object.entries(countriesConfig).map(([countryCode, { rootIddCode, i18nNames }]) => ({
                    countryCode,
                    rootIddCode,
                    label: i18nNames[locale.value as Locale],
                })),
                ['label' satisfies keyof CountryOption]
            )
        ),

        getLocalizedCountry,

        makeReactiveLocalizedCountry: countryCode => computed(() => getLocalizedCountry(toValue(countryCode))),
    };
};
